import TenantPortalVideoSlot from './TenantPortalVideoSlot';
import {
  PROSPECT_PORTAL_PAGE_SLUG,
  QUALIFICATION_LANDING_VIDEO_SECTION,
} from '../../constants/liveWithUsPortalContent';
import type { PortalContentEngagementRollup } from '../../services/tenantApi';

export default function QualificationLandingVideoSection({
  className = 'mb-4 sm:mb-6',
  title = "What we'll cover",
  description = 'A short look at the discovery call before you pick a time.',
  placeholderLabel = 'Discovery call',
  sectionName = QUALIFICATION_LANDING_VIDEO_SECTION,
  titleClassName,
  descriptionClassName,
  headerClassName,
  bodyClassName,
  playerAspectClass,
  centerInCard = false,
  minuteStep = false,
  onEngagement,
}: {
  className?: string;
  title?: string;
  description?: string;
  placeholderLabel?: string;
  sectionName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  headerClassName?: string;
  bodyClassName?: string;
  playerAspectClass?: string;
  centerInCard?: boolean;
  minuteStep?: boolean;
  onEngagement?: (engagement: PortalContentEngagementRollup | null) => void;
}) {
  return (
    <TenantPortalVideoSlot
      className={className}
      pageSlug={PROSPECT_PORTAL_PAGE_SLUG}
      sectionName={sectionName}
      fetchPlayback
      placeholderLabel={placeholderLabel}
      placeholderSublabel="Video coming soon"
      title={title}
      description={description}
      titleClassName={titleClassName}
      descriptionClassName={descriptionClassName}
      headerClassName={headerClassName}
      bodyClassName={bodyClassName}
      playerAspectClass={playerAspectClass}
      centerInCard={centerInCard}
      minuteStep={minuteStep}
      onEngagement={onEngagement}
    />
  );
}
